import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {

  constructor() { }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  public getToken(): string {
    try {
      const token = localStorage.getItem('token');
      return token ? JSON.parse(token) : '';
    } catch {
      return '';
    }
  }

  public getLLMToken(): string {
    try {
      const llmToken = localStorage.getItem('llm_token');
      return llmToken ? JSON.parse(llmToken) : '';
    } catch (error) {
      console.log(error);      
      return '';
    }
  }

  public getLoggedUserRole() {
    try {
      const isUserRole = localStorage.getItem('user_role');

      return isUserRole;
    } catch (error) {
      console.log(error);
      return '';
    }
  }
}
